/* eslint-disable import/prefer-default-export */
export const API_URL = {
    assets: '/assets/getAssetNavigation',
    saveGroup: '/apcm_groups',
    getGroupsById: '/apcm_groups',
    getAllGroups: '/apcm_groups/getAll',
    getGroupByName: 'apcm_groups/getBySearch',
    addUser: '/user',
    userByAppType: '/user/getAll',
    savePrice: '/price_request',
    executePriceRequest: '/price_request/executePriceRequest',
    requestsByPage: '/price_request/getByPage',
    getAllPrice: '/price_request/getAll',
    changeUserPassword: 'user/changePassword',
    changeControlPassword: 'user/changeControlPassword',
    executersData: '/price_request/getByYesExecutedPriceRequest',
    confirmedData: '/price_request/getYesConfirmedPriceRequest',
    getAPCMEvents: 'apcm_user_events/events/50',
    getAPCMFilteredEvents: 'apcm_user_events/byDate',
    getEmails: 'user/getAllEmails',
    getUserUnitCount: 'user/getAllUnitIdsCount',
    // getRequestLog:'price_request_log/getAll',
    getExecutedLogs: '/price_executed_logs/getAll',
    getRole: 'role/getAll',
    getRequestByGroupId: '/price_request/byGroupID',
    getYesRequestByGroupId: '/price_request/byGroupIDYesConfirmed',
    getPriceLogsByID: 'price_executed_logs/byPriceRequestID',
    getAssetsLiveData: '/assets/get_assets_live_value',
    getAssetCount: '/assets/getByAPCMAssetsCount',
    getGroupCount: '/apcm_groups/getByGroupsCount',
    getUserCount: '/user/getByAPCMUserCount',
    getPriceCount: '/price_request/getByPriceRequestRaisedCount',
    getExecutedCount: '/price_request/getByPriceRequestExecutedYesCount',
    getPriceCountByID: '/price_request/getPriceRequestRaisedCountByGroupId',
    getExecutedCountByID:
        '/price_request/getPriceRequestExecutedYesCountByGroupId',
    getExecutedDataByID: '/price_request/getYesExecutedPriceRequestByGroupId',
    getPriceReqRaisedByID: '/price_request/getPriceRequestRaisedByGroupId',
    groupInfo: 'apcm_groups/getGroupInfo',
    pendingConfirmedData: '/price_request/getPriceRequestConfirmedNoByGroupId',
    pendingConfirmed: '/price_request/getPriceRequestConfirmedNoCountByGroupId',
    pendingExecutedData: '/price_request/getPriceRequestExecutedNoByGroupId',
    pendingExecuted: '/price_request/getPriceRequestExecutedNoCountByGroupId',
    executedAllRequests: '/price_request/getByYesExecutedPriceRequestAll',
    executedAllRequestsByID:
        '/price_request/getYesExecutedPriceRequestByGroupIdAll',
    getRetryRequest: '/price_executed_logs/retryPriceRequest',
    getCancelRequest: '/price_executed_logs/cancelPriceRequest ',

    general_setting: '/general_setting',
    login: '/user/loginByOTP',
    home: '/dashbord/getHomePageOfUser',
    tagUnitIds: '/tag/getAllTagNamesByUnitIds',
    tagMultipleCollections: '/log_tags_data/getTagsMultipleCollections',
    dashboard: '/dashbord',
    setHomePage: '/dashbord/setHomePageToUser',
    getLive: '/log_tags_data/getLive',
    getTagByName: '/tag/getByName',
    liscense: '/slt/init',
    getDataForBarChart: '/log_tags_data/getDataForBarChart',
    getAllGLGFiles: '/glg/getAll',
    getLiveByProp: '/log_tags_data/liveTagProperty',
    writeValue: '/write',
    downloadGLG: '/glg/download',
    getAssetIdByUnitIds: '/assets/getAssetIdByUnitIds',
    getAllByAssetId: '/getAllByAssetId',
    getTokenByUsername: '/user/getUserInfo',
    logout: '/user/logout',
    getCaptcha: '/captcha/get',
    verifyCaptcha: '/captcha/verify',
};
